// How the report's numbers read. Plain functions with block bodies (the bundler mangles a returned `new Date(...)`).
export const num = (v: number | null | undefined, digits = 0): string =>
  v === null || v === undefined ? '–' : v.toLocaleString(undefined, { maximumFractionDigits: digits, minimumFractionDigits: digits });

export const raw = (v: number | null | undefined): string => (v === null || v === undefined ? '–' : String(Math.round(v * 10000) / 10000));

// A change as a signed number; one that rounds to nothing reads "0", never "-0" or "+0".
export const signed = (v: number, digits = 0): string => {
  const r = Number(v.toFixed(digits));
  return r === 0 ? num(0, digits) : (r > 0 ? '+' : '') + num(r, digits);
};

/** A value with its unit as the athlete reads it: joules as kJ, watts, a training load to one decimal. */
export function withUnit(unit: string, v: number | null | undefined): string {
  if (v === null || v === undefined) return '–';
  if (unit === 'J') return `${num(v / 1000, 1)} kJ`;
  if (unit === 'W') return `${num(v)} W`;
  return num(v, 1);
}

export function changeWithUnit(unit: string, v: number): string {
  if (unit === 'J') return `${signed(v / 1000, 1)} kJ`;
  if (unit === 'W') return `${signed(v)} W`;
  return signed(v, 1);
}

export function fmtDate(d: string | null | undefined, style: 'long' | 'short' = 'long'): string {
  if (!d) return '';
  const date = new Date(d.slice(0, 10) + 'T12:00:00');
  return style === 'short' ? date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }) : date.toLocaleDateString(undefined, { dateStyle: 'long' });
}

export function durationName(s: number): string {
  if (s < 60) return `${Math.round(s)}-second`;
  if (s <= 7200 && s % 60 === 0) return `${s / 60}-minute`;
  if (s < 3600) return `${Math.floor(s / 60)}:${String(Math.round(s % 60)).padStart(2, '0')}-minute`;
  return `${Math.round((s / 3600) * 10) / 10}-hour`;
}

export function shortDuration(s: number): string {
  if (s < 60) return `${s}s`;
  if (s < 3600) return `${s / 60}m`;
  return `${s / 3600}h`;
}
